var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$auth.isAuthenticated && _vm.$auth.user.email)?_c('div',{attrs:{"id":"app"}},[_c('router-view')],1):_c('div',{staticClass:"bg-primary show",attrs:{"id":"page-loader"}})}
var staticRenderFns = []

export { render, staticRenderFns }